var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var globalStyles = function (_a) {
    var _b;
    var typography = _a.typography;
    return (_b = {},
        _b["html,\n  body,\n  div,\n  span,\n  applet,\n  object,\n  iframe,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  blockquote,\n  pre,\n  a,\n  abbr,\n  acronym,\n  address,\n  big,\n  cite,\n  code,\n  del,\n  dfn,\n  em,\n  img,\n  ins,\n  kbd,\n  q,\n  s,\n  samp,\n  small,\n  strike,\n  strong,\n  sub,\n  sup,\n  tt,\n  var,\n  b,\n  u,\n  i,\n  center,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  article,\n  aside,\n  canvas,\n  details,\n  embed,\n  figure,\n  figcaption,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  output,\n  ruby,\n  section,\n  summary,\n  time,\n  mark,\n  audio,\n  video"] = {
            margin: 0,
            padding: 0,
            border: 0,
            fontSize: "100%",
            font: "inherit",
            fontVariantNumeric: "slashed-zero",
            verticalAlign: "baseline",
        },
        _b.button = {
            font: "inherit",
        },
        _b["article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  section"] = {
            display: "block",
        },
        _b["ol,ul"] = {
            listStyle: "none",
        },
        _b["blockquote,q"] = {
            quotes: "none",
        },
        _b["blockquote:before,blockquote:after,q:before,q:after"] = {
            content: "none",
        },
        _b.table = {
            borderCollapse: "collapse",
            borderSpacing: 0,
        },
        _b["body, input, textarea, button, select"] = __assign({}, typography.body2),
        _b.strong = {
            fontWeight: typography.fontWeightBold,
        },
        _b.b = {
            fontWeight: typography.fontWeightBold,
        },
        _b);
};
